<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-30 inset-0 overflow-y-auto" @close="closeModal">
      <div
        class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block
          sm:p-0
        "
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              relative
              inline-block
              align-bottom
              bg-vice-dark-grey
              rounded-lg
              text-left
              shadow-xl
              transform
              transition-all
              sm:align-middle
              p-5
              sm:max-w-md
              sm:w-full
            "
          >
            <p class="text-white pb-5 font-bold">Connect {{ steps[0].label }}</p>

            <div class="flex flex-col items-center justify-between max-w-md mx-auto">
              <div class="w-full bg-black py-4 qrCode">
                <SmartphoneQRcode
                  v-if="steps[0].label === 'smartphone'"
                  :sessionId="sessionId"
                  class="bg-white p-2 max-w-min mx-auto"
                />
                <Qrcode v-else :sessionId="sessionId" class="bg-white p-2 max-w-min mx-auto" />
              </div>
              <div
                class="
                  w-2/3
                  px-4
                  bg-vice-light-grey
                  checklist
                  rounded-br-lg rounded-tr-lg
                  flex flex-col
                  justify-center
                "
              >
                <div
                  class="absolute right-6 top-8 block transform translate-x-1/2 -translate-y-1/2"
                >
                  <button @click="closeModal" class="text-white"><XMarkIcon></XMarkIcon></button>
                </div>
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3';
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import Qrcode from '../QRcode.vue';
import XMarkIcon from '../Icons/XMarkIcon.vue';
import SmartphoneQRcode from '@/Components/SmartphoneQRcode.vue';

export default {
  name: 'ConnectStethoscopeModal',
  components: {
    SmartphoneQRcode,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    Qrcode,
    XMarkIcon,
  },
  emits: ['closeConnectDeviceModal'],
  props: {
    steps: {
      type: Object,
    },
    open: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const pageProps = usePage().props.value;
    const closeModal = () => {
      emit('close');
    };
    const sessionId = pageProps.session.unique_id.replace(/-/g, '');

    return {
      closeModal,
      sessionId,
    };
  },
};
</script>
